import React from 'react'
import { IoMdCheckmark, IoMdClose } from 'react-icons/io'
import { compareConstant } from '../../../_constants/Config/compareConfig';
import MultiLanguageTranslation from '../../../_components/Translate/MultiLangTranslate'

class CompareListitem extends React.Component {
    camelCase(aa) {
        if (aa !== null && aa !== undefined) {
            var k = aa.toString().toLowerCase().split(' ')
            var c = ""
            k.map((data, index) => {
                c = c + " " + data.charAt(0).toUpperCase() + data.substring(1)
            })
            return c.replace(" Mt", " MT")
        } else {
            return ""
        }
    }

    multiLingualFun = (content,check) => {
        let local = content.replace(":"," ")
        return <MultiLanguageTranslation title={local} />
    }
    render() {
        const keyName = compareConstant.keyName;
        return <React.Fragment>

            {this.props.textual ?

                (this.props.active === 0 || this.props.active === 1 ||keyName[this.props.keyName]) ? <tr>
                    {this.props.column !== 3 ?
                        <th>{this.multiLingualFun(this.camelCase(keyName[this.props.keyName]))}</th>
                        :
                        null
                    }
                    {this.props.datalist.map(value => {
                        return <td>{this.camelCase(value)}</td>
                    })}
                </tr> : null
                :

                keyName[this.props.keyName] ? <tr>
                    <th>{keyName[this.props.keyName] && this.multiLingualFun(this.camelCase(keyName[this.props.keyName]))}</th>
                    {this.props.datalist.map(value => {
                        if (value) {
                            return <td>
                                <IoMdCheckmark size="30" color="#5c6b25" />
                            </td>
                        } else {
                            return <td>
                                <IoMdClose size="30" color="#6d6e71" />
                            </td>
                        }
                    })}
                </tr> : null
            }
        </React.Fragment>
    }
}
export default CompareListitem